(function () {
  const BODY_CHROME_HIDDEN_CLASS = 'spring-pre-nav-chrome-hidden';

  const TOP_CHROME_SECTION_SELECTORS = [
    '#shopify-section-announcement',
    '#shopify-section-announcement-special-page',
    '#shopify-section-experience-announcement',
  ];

  function resolveTarget(targetId) {
    if (!targetId) return null;

    let el = document.getElementById(targetId);
    if (el) return el;

    el = document.querySelector(`[id$="__${targetId}"]`);
    if (el) return el;

    el = document.querySelector(`[id$="${targetId}"]`);
    if (el) return el;

    return null;
  }

  function getElementTop(el) {
    return el.getBoundingClientRect().top + window.pageYOffset;
  }

  document.addEventListener('DOMContentLoaded', () => {
    const nav = document.getElementById('spring-sale-pre-nav');
    if (!nav) return;

    const revealOnScroll = nav.getAttribute('data-reveal-on-scroll') === 'true';
    const revealTriggerId = (nav.getAttribute('data-reveal-trigger') || '').trim();
    const is15thAnniversaryNav = nav.classList.contains('nav-15th-anniversary');
    const navSectionWrap = nav.closest('.shopify-section');
    const navItems = nav.querySelectorAll('.nav-wrapper .nav');
    const header = document.querySelector('.site-header');
    // 15 周年 reveal 导航：区块顶与 nav 下沿对齐，避免多出一条底色缝
    const baseOffset = is15thAnniversaryNav ? 0 : 8;
    const sections = [];
    let scrollLockUntil = 0;
    let scrollEndTimer = null;
    let revealTriggerEl = null;

    const measureTopChromeHeight = () => {
      if (document.body.classList.contains(BODY_CHROME_HIDDEN_CLASS)) return 0;

      let total = 0;
      TOP_CHROME_SECTION_SELECTORS.forEach((selector) => {
        document.querySelectorAll(selector).forEach((el) => {
          total += el.offsetHeight;
        });
      });

      if (header) {
        total += header.offsetHeight;
      }

      return total;
    };

    const syncChromeHidden = () => {
      const hidden =
        nav.classList.contains('fixed') || nav.classList.contains('is-visible');
      document.body.classList.toggle(BODY_CHROME_HIDDEN_CLASS, hidden);
    };

    let headerHeight = measureTopChromeHeight();
    let navTop = getElementTop(nav);
    let triggerPoint = navTop - headerHeight;

    function setNavFixed(fixed) {
      const isFixed = nav.classList.contains('fixed');
      if (fixed === isFixed) return;

      if (fixed) {
        const navHeight = nav.offsetHeight;
        nav.classList.add('fixed');
        nav.style.top = '0px';
        if (navSectionWrap && navHeight > 0) {
          navSectionWrap.style.minHeight = `${navHeight}px`;
        }
      } else {
        nav.classList.remove('fixed');
        nav.style.top = '';
        if (navSectionWrap) {
          navSectionWrap.style.minHeight = '';
        }
      }

      syncChromeHidden();
    }

    function setRevealVisible(visible) {
      const wasVisible = nav.classList.contains('is-visible');
      if (wasVisible === visible) return;

      nav.classList.toggle('is-visible', visible);
      syncChromeHidden();
    }

    function getStickyOffset() {
      return nav.offsetHeight + baseOffset;
    }

    function getViewportMarker() {
      if (revealOnScroll) {
        const isVisible = nav.classList.contains('is-visible');
        const navHeight = isVisible ? nav.offsetHeight : 0;
        const hHeight = isVisible ? 0 : measureTopChromeHeight();
        return hHeight + navHeight + baseOffset;
      }

      if (nav.classList.contains('fixed')) {
        return getStickyOffset();
      }
      const headerPart = measureTopChromeHeight();
      const inFlowNav = is15thAnniversaryNav ? nav.offsetHeight : 0;
      return headerPart + inFlowNav + baseOffset;
    }

    function getScrollOffset() {
      return getViewportMarker();
    }

    function scrollSectionIntoView(sectionEl) {
      if (revealOnScroll) {
        const marker = getScrollOffset();
        const sectionTop = getElementTop(sectionEl);
        const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
        const targetScroll = Math.max(0, Math.min(sectionTop - marker, maxScroll));

        window.scrollTo({
          top: targetScroll,
          behavior: 'smooth',
        });
        return;
      }

      // 先进入吸顶终态再测量。fixed 会让后续内容上跳一截，必须用跳完后的位置计算。
      setNavFixed(true);
      void nav.offsetHeight;

      if (
        !is15thAnniversaryNav &&
        typeof window.__pdPreLotteryPrepareOverlapForTarget === 'function'
      ) {
        window.__pdPreLotteryPrepareOverlapForTarget(sectionEl);
      }

      const marker = getStickyOffset();
      const sectionTop = getElementTop(sectionEl);
      const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
      let targetScroll = sectionTop - marker;

      // 15 周年页（含 map）：与 reveal 一致，区块顶对齐到 nav 下沿，不做短区块垂直居中
      if (!is15thAnniversaryNav) {
        const availableHeight = window.innerHeight - marker;
        const sectionHeight = sectionEl.getBoundingClientRect().height;
        if (sectionHeight <= availableHeight) {
          targetScroll = sectionTop - marker - (availableHeight - sectionHeight) / 2;
        }
      }

      window.scrollTo({
        top: Math.max(0, Math.min(targetScroll, maxScroll)),
        behavior: 'smooth',
      });
    }

    function updateRevealFromViewport() {
      if (!revealOnScroll || !revealTriggerEl) return;
      const bottom = revealTriggerEl.getBoundingClientRect().bottom;
      setRevealVisible(bottom <= 0);
    }

    function recalcRevealTrigger() {
      if (!revealOnScroll) return;

      const matched = resolveTarget(revealTriggerId);
      revealTriggerEl = matched ? matched.closest('.shopify-section') || matched : null;
    }

    function recalcOffsets() {
      if (revealOnScroll) {
        recalcRevealTrigger();
        return;
      }

      const wasFixed = nav.classList.contains('fixed');
      setNavFixed(false);

      headerHeight = measureTopChromeHeight();
      navTop = getElementTop(nav);
      triggerPoint = navTop - headerHeight;

      if (wasFixed && window.scrollY > triggerPoint) {
        setNavFixed(true);
      }
    }

    function setActiveNav(targetId) {
      navItems.forEach((item) => {
        item.classList.toggle('active', item.getAttribute('data-section') === targetId);
      });
    }

    function updateActiveNav() {
      if (Date.now() < scrollLockUntil) return;
      if (!sections.length) return;

      const marker = getViewportMarker();
      let currentId = sections[0].id;

      sections.forEach((section) => {
        if (section.el.getBoundingClientRect().top <= marker + 1) {
          currentId = section.id;
        }
      });

      setActiveNav(currentId);
    }

    function lockScrollSpy(ms) {
      scrollLockUntil = ms ? Date.now() + ms : Number.POSITIVE_INFINITY;
    }

    function onScrollEnd() {
      scrollLockUntil = 0;
      updateActiveNav();
    }

    function onScroll() {
      if (revealOnScroll) {
        updateRevealFromViewport();
      } else if (window.scrollY > triggerPoint) {
        setNavFixed(true);
      } else {
        setNavFixed(false);
      }

      clearTimeout(scrollEndTimer);
      scrollEndTimer = setTimeout(onScrollEnd, 120);

      updateActiveNav();
    }

    recalcOffsets();
    window.addEventListener('resize', () => {
      recalcOffsets();
      updateActiveNav();
    });

    navItems.forEach((item) => {
      const targetId = item.getAttribute('data-section');
      const el = resolveTarget(targetId);
      if (el) {
        sections.push({ id: targetId, el });
      }
    });

    sections.sort((a, b) => getElementTop(a.el) - getElementTop(b.el));

    navItems.forEach((item) => {
      item.addEventListener('click', (e) => {
        e.preventDefault();

        const navTargetId = item.getAttribute('data-section');
        let scrollTargetId = navTargetId;

        if (scrollTargetId === 'hot-sale') {
          scrollTargetId = window.innerWidth < 768 ? 'hot-sale-nav' : 'hot-sale';
        }

        const sectionRoot = resolveTarget(scrollTargetId);

        if (sectionRoot) {
          if (revealOnScroll) {
            setRevealVisible(true);
            void nav.offsetHeight;
          }

          lockScrollSpy(800);
          setActiveNav(navTargetId);
          scrollSectionIntoView(sectionRoot);
          clearTimeout(scrollEndTimer);
          scrollEndTimer = setTimeout(onScrollEnd, 1000);

          if (window.dataLayer) {
            window.dataLayer.push({ event_parameters: null });
            window.dataLayer.push({
              event: 'ga4Event',
              event_name: 'select_content_category',
              event_parameters: {
                button_name: item.textContent?.trim(),
                content_type: 'navbar',
              },
            });
          }
        }
      });
    });

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    updateActiveNav();
  });
})();
